export default {"src":"/_next/static/media/error-free-2.f4013d46.svg","height":56,"width":49,"blurWidth":0,"blurHeight":0};